module.exports = __webpack_public_path__ + "static/media/voltroph-new.790f5678.webp";